import * as React from 'react';
import { useSplunkTheme } from '@splunk/themes';
import SvgIcon from '@splunk/react-icons/SVG';
import { _ } from '@splunk/ui-utils/i18n';
import NoTokensLight from './NoTokensLight';
import NoTokensDark from './NoTokensDark';

const NoTokensFound = ({
    width = 64,
    height = 64,
    ...rest
}: React.SVGAttributes<SVGSVGElement>) => {
    const { colorScheme } = useSplunkTheme();

    return (
        <SvgIcon
            width={width}
            height={height}
            viewBox="0 0 480 552"
            aria-label={_('No tokens found')}
            {...rest}
        >
            {colorScheme === 'dark' ? <NoTokensDark /> : <NoTokensLight />}
        </SvgIcon>
    );
};

export default NoTokensFound;
